import Vue from "vue"
import Vuex from "vuex"
import auth from "../features/auth/store/index"
import routes from "../features/routes/store/index"
import bonus from "../features/bonus/store/index"
import routeItems from "../features/routeItems/store/index"
import processFields from "../features/routeItemFields/store/index"
import administrativeCorrections from "../features/administrativeCorrections/store/index"

Vue.use(Vuex)

const modules = {
  auth,
  routes,
  bonus,
  routeItems,
  processFields,
  administrativeCorrections,
}

export default new Vuex.Store({
  modules,
  state: {
    requests: JSON.parse(localStorage.getItem("requests") as any) || [],
  },
  mutations: {
    updateStorage(state, array) {
      state.requests = array
      localStorage.setItem("requests", JSON.stringify(array))
    },
  },
})
